module.exports = __webpack_public_path__ + "static/media/img_apis_01.829bb7ff.png";